// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;&#145;And now, what is my hope?&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Truly my hope is even in you.<br> </p> </div></div>";
// Exports
module.exports = code;